import { BaseAnalyticsFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { FilterIcon } from 'lucide-react';
import { formatPeriod } from '../../utils/dataUtils';

interface FilterSummaryProps {
  filters?: BaseAnalyticsFilter;
}

function buildFilterText(filters?: BaseAnalyticsFilter): string {
  const parts: string[] = [];
  if (filters?.startDate) parts.push(`From: ${formatPeriod(filters.startDate, 'date')}`);
  if (filters?.endDate) parts.push(`To: ${formatPeriod(filters.endDate, 'date')}`);
  if (filters?.experienceTitle) parts.push(`Session: ${filters.experienceTitle}`);
  if (filters?.unitIds?.length) parts.push(`Units: ${filters.unitIds.length} selected`);
  return parts.length > 0 ? parts.join(' | ') : 'All data';
}

export function FilterSummary({ filters }: FilterSummaryProps) {
  const filterText = buildFilterText(filters);

  return (
    <div className="mb-6 flex items-center space-x-2 rounded-lg border border-[var(--anl-border)] bg-[var(--anl-surface-elev)] p-4">
      <FilterIcon className="h-5 w-5 text-[var(--anl-text-muted)]" />
      <p className="text-sm text-[var(--anl-text-muted)]">{filterText}</p>
    </div>
  );
}
